import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';
import { toast } from 'react-toastify';

// ✅ Fetch Clinic Profile
export const fetchClinicProfile = createAsyncThunk(
  'clinic/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/clinics/profile/');
      return response.data; // ✅ Directly returning clinic object
    } catch (error) {
      return rejectWithValue(
        error.response?.data || 'Failed to fetch clinic profile'
      );
    }
  }
);

// ✅ Update Clinic Profile
export const updateClinicProfile = createAsyncThunk(
  'clinic/updateProfile',
  async (clinicData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put('/clinics/profile/', clinicData);
      toast.success('Clinic details updated successfully!');
      return response.data;
    } catch (error) {
      toast.error('Failed to update clinic details.');
      return rejectWithValue(
        error.response?.data || 'Failed to update clinic profile'
      );
    }
  }
);

// 🔹 Create Clinic Profile Slice
const clinicProfileSlice = createSlice({
  name: 'clinic',
  initialState: { data: null, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClinicProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchClinicProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchClinicProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateClinicProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateClinicProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateClinicProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default clinicProfileSlice.reducer;
